<template>
  <b-row class="m-0">
    <b-col cols="12" lg="8" class="px-4 py-3 text-center text-lg-left">
      <div
        v-if="etapaProceso === 'COMPLEMENTARIO'"
        class="bg-naranja-light mt-1 py-1 px-1 px-lg-1 d-block d-md-flex text-center text-md-left"
      >
        <div class="text-naranja font-weight-bold text-center h5 mb-2 mb-md-0">
          <FontAwesomeIcon icon="exclamation-circle" class="h4 mb-0" />Recuerda
        </div>
        <div class="border-right border-gris mx-3 d-none d-md-block"></div>
        <div class="text-morado-claro">
          <p>
            Únicamente se muestran aquellos colegios que cuentan con vacantes
            disponibles.
          </p>
        </div>
      </div>
      <template v-for="filtro in filtros">
        <b-badge
          variant="secondary"
          class="pt-1 bg-morado-oscuro ml-1"
          v-for="(f, index) in filtro.filtros"
          :key="f + index"
        >
          {{ traducirFiltroATexto(f) }}
          <a
            @click="eliminarFiltro(f, filtro.tipo)"
            class="pointer ml-1 pl-1 border-left border-azul-medio text-white"
          >
            <FontAwesomeIcon icon="times" />
          </a>
        </b-badge>
      </template>
    </b-col>

    <b-col
      cols="12"
      lg="4"
      class="text-center text-lg-right px-4 py-2 text-morado-claro align-bottom align-items-center d-flex justify-content-center justify-content-lg-end"
    >
      <strong>{{ textoEstablecimientos1 }}</strong>
      &nbsp;{{ textoEstablecimientos2 }}
    </b-col>
  </b-row>
</template>

<script>
import Filtros from "@/utils/Filtros";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faTimes, faExclamationCircle);
export default {
  props: {
    filtros: {
      type: Array,
      required: true
    },
    numeroEstablecimientos: {
      type: Number,
      requiered: true
    },
    orden: {
      type: Object,
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      etapaProceso: localStorage.getItem("etapaVitrina") || "NORMAL"
    };
  },
  computed: {
    // calcula texto de cantidad de establecimientos en la vitrina
    textoEstablecimientos1() {
      return (
        this.numeroEstablecimientos +
        (this.numeroEstablecimientos !== 1
          ? " Establecimientos"
          : " Establecimiento")
      );
    },
    // calcula segundo fragmento de texto de cantidad de establecimientos en la vitrina
    textoEstablecimientos2() {
      return this.numeroEstablecimientos !== 1 ? "encontrados" : "encontrado";
    }
  },
  methods: {
    //emite evento de eliminacion a componente VistaVitrina
    eliminarFiltro: function(valor) {
      this.$emit("removerFiltro", valor);
    },
    //traduce un filtro a texto
    traducirFiltroATexto(filtro) {
      return Filtros.traducirFiltro(filtro);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/filtros/BarraTags.vue